

import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { GridContainer } from '../../global';

import { 
    PostContainer, PostContent, BannerContainer, PostHeaderImage, 
    BannerContent, BannerTitle, NavArrow, ScrollDownContainer,
    NextPostBanner, NextPostContent, PostMeta, TagBadge
} from './style';

const SPACE_ID = 'js0jco2wnv88';
const ACCESS_TOKEN = '7iNOSfMbMjQFx6ffcZmKI8iuXt9CWsWkYfK5PrqifoE';

function BlogPost() {
    const { slug } = useParams();
    const location = useLocation();
    const allPosts = location.state?.allPosts;

    const [post, setPost] = useState(null);
    const [assets, setAssets] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      
        const url = `https://cdn.contentful.com/spaces/${SPACE_ID}/environments/master/entries?access_token=${ACCESS_TOKEN}&content_type=post&fields.slug=${slug}`;
        fetch(url)
            .then(response => response.json())
            .then(data => {
                if (data.items.length > 0) {
                    setPost(data.items[0]);
                    setAssets(data.includes?.Asset || []);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar o post:", error);
                setLoading(false);
            });
    }, [slug]);

    const handleScrollDown = () => {
        const contentElement = document.getElementById('post-content');
        if (contentElement) {
           
            contentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const options = {
       
        renderNode: {
            [BLOCKS.EMBEDDED_ASSET]: (node) => {
                const asset = assets.find((asset) => asset.sys.id === node.data.target.sys.id);
                if (asset && asset.fields.file.contentType.startsWith('image/')) {
                    return <img src={'https:' + asset.fields.file.url} alt={asset.fields.description || asset.fields.title} style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }} />;
                }
                return null;
            },
        },
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('pt-BR', options);
    };

    if (loading) return <p style={{textAlign: "center", padding: "50px"}}>Carregando...</p>;
    if (!post) return <p style={{textAlign: "center", padding: "50px"}}>Post não encontrado.</p>;

  
    let currentIndex = -1;
    if (allPosts) {
        currentIndex = allPosts.findIndex(p => p.sys.id === post.sys.id);
    }
    const prevPost = currentIndex > 0 ? allPosts[currentIndex - 1] : null;
    const nextPost = (currentIndex !== -1 && currentIndex < allPosts.length - 1) ? allPosts[currentIndex + 1] : null;

 
    const featuredImageAsset = assets.find(a => a.sys.id === post.fields.imagemDestacada?.sys?.id);
    const featuredImageUrl = featuredImageAsset ? 'https:' + featuredImageAsset.fields.file.url : '';
    
    let nextPostImageUrl = '';
    if (nextPost) {
      
        const nextPostImageAsset = allPosts.find(p => p.sys.id === nextPost.sys.id);
        nextPostImageUrl = nextPostImageAsset?.imageUrl || '';
    }

    return (
        <div>
       
            <BannerContainer>
                <PostHeaderImage src={featuredImageUrl} />
                <BannerContent>
                    <NavArrow 
                        to={prevPost ? `/blog/${prevPost.fields.slug}` : '#'} 
                        state={{ allPosts: allPosts }} 
                        className={!prevPost ? 'disabled' : ''}
                        title={prevPost ? 'Post anterior' : ''}
                    >
                        <img src="/icone/seta-para-a-esquerda.png" alt="Post Anterior" />
                    </NavArrow>

                    <BannerTitle>{post.fields.titulo}</BannerTitle>

                    <NavArrow 
                        to={nextPost ? `/blog/${nextPost.fields.slug}` : '#'} 
                        state={{ allPosts: allPosts }} 
                        className={!nextPost ? 'disabled' : ''}
                        title={nextPost ? 'Próximo post' : ''}
                    >
                        <img src="/icone/seta-para-a-direita.png" alt="Próximo Post" />
                    </NavArrow>
                </BannerContent>
                <ScrollDownContainer onClick={handleScrollDown} title="Ler o artigo">
                    <img src="/icone/seta-para-a-baixo.png" alt="Rolar para baixo" />
                </ScrollDownContainer>
            </BannerContainer>
            
            {/* --- CONTEÚDO DO POST --- */}
            <GridContainer>
                <PostContainer id="post-content">
          <PostMeta>
                        <span>Publicado em {formatDate(post.fields.dataDePublicao)}</span>
                        
                        {post.fields.categoria && (
                            <span className="category">
                                <strong>Categoria:</strong> {post.fields.categoria}
                            </span>
                        )}

                        {post.fields.tags && post.fields.tags.length > 0 && (
                            <div className="tags-container">
                                {post.fields.tags.map(tag => (
                                    <TagBadge key={tag}>{tag}</TagBadge>
                                ))}
                            </div>
                        )}
                    </PostMeta>
                    
                    <PostContent>
                        {documentToReactComponents(post.fields.contedoCompleto, options)}
                    </PostContent>
                </PostContainer>
            </GridContainer>

            {/* --- NOVA SEÇÃO: PRÓXIMO ARTIGO --- */}
            {nextPost && nextPostImageUrl && (
                <NextPostBanner 
                    to={`/blog/${nextPost.fields.slug}`} 
                    state={{ allPosts: allPosts }}
                    bgimage={nextPostImageUrl}
                >
                    <NextPostContent>
                        <span>Próximo Artigo</span>
                        <h3>{nextPost.fields.titulo}</h3>
                    </NextPostContent>
                </NextPostBanner>
            )}
        </div>
    );
}

export default BlogPost;